// DS: IL3.6
import React from 'react';

export interface Props {
  className?: string;
}

export const PremiumTrash: React.FC<Props> = ({ className }) => {
  return (
    <img
      alt=""
      src="https://st.deviantart.net/eclipse/global/svg/il05-delete.svg"
      width="90"
      height="88"
      className={className}
    />
  );
};
